import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { NAV_ITEMS } from './navigation';

export function CommandPalette({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return NAV_ITEMS;
    return NAV_ITEMS.filter((item) => item.label.toLowerCase().includes(q));
  }, [query]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Command palette"
      className="command-palette-overlay"
      onClick={onClose}
    >
      <div className="command-palette-panel" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Navigate routes, tickers, glossary…"
          className="command-palette-input"
          aria-label="Command search"
        />
        <ul className="command-palette-list">
          {filtered.map((item) => (
            <li key={item.path}>
              <button
                type="button"
                className="command-palette-item"
                onClick={() => {
                  navigate({ to: item.path });
                  onClose();
                }}
              >
                <span>{item.label}</span>
                <kbd>G {item.shortcut}</kbd>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
